<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Diary Reports
    </h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <form [formGroup]="diaryForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label for="approversName" class="form-label col-sm-3"
              >From Date <span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <div class="input-group">
                <input
                  class="form-control form-control-xs"
                  placeholder="dd/mm/yyyy"
                  name="fromDate"
                  id="fromDate"
                  ngbDatepicker
                  #fromDate="ngbDatepicker"
                  formControlName="fromDate"
                  [placement]="'bottom'"
                  [class.is-invalid]="formErrors.fromDate && formSubmitted"
                  matTooltip="{{ formErrors.fromDate }}"
                  matTooltipPosition="above"
                  matTooltipClass="warn-tooltip"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-outline-theme calendar"
                    (click)="fromDate.toggle()"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="row">
            <label for="toDate" class="form-label col-sm-3"
              >To Date<span class="text-danger">*</span>
            </label>
            <div class="col-sm-6">
              <div class="input-group">
                <input
                  class="form-control form-control-xs"
                  placeholder="dd/mm/yyyy"
                  name="toDate"
                  ngbDatepicker
                  #toDate="ngbDatepicker"
                  formControlName="toDate"
                  [placement]="'bottom'"
                  [minDate]="diaryForm.value.fromDate"
                  (dateSelect)="loadLookupForManageProfile()"
                  [class.is-invalid]="formErrors.toDate && formSubmitted"
                  matTooltip="{{ formErrors.toDate }}"
                  matTooltipPosition="above"
                  matTooltipClass="warn-tooltip"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-outline-theme calendar"
                    (click)="toDate.toggle()"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-6">
          <div class="row">
            <label for="" class="form-label col-sm-3"
              >Clients <span class="text-danger">*</span></label
            >
            <div class="col-sm-5">
              <mat-form-field>
                <mat-select
                  formControlName="clients"
                  multiple
                  [class.is-invalid]="formErrors.clients && formSubmitted"
                  matTooltip="{{ formErrors.clients }}"
                >
                  <mat-option
                    [value]="1"
                    (click)="selectAllClient(clients)"
                    #clients
                    >Select All
                  </mat-option>
                  <mat-option
                    *ngFor="let client of clientList"
                    [value]="client"
                  >
                    {{ client.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-sm-2 mt-2">
          <button
            id="saveFyBtn"
            name="saveFyBtn"
            type="button"
            class="btn btn-sm btn-block btn-outline-theme"
            (click)="onViewReport()"
          >
            View Report
          </button>
        </div>
        <div class="col-sm-2 mt-2" *ngIf="showReports && reports.length > 0">
          <button
            (click)="exportToExcelClick()"
            class="btn btn-sm btn-block btn-outline-theme"
          >
            <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
          </button>
        </div>
      </div>
    </form>
  </div>
  </div>
<br>
  <div class="container" id="mainContent">
  <div class="" *ngIf="showReports">
    <div class="row pt-3">
      <div class="col-md-10">
        <span style="padding-left: 40%" class="bg-theme-title"
          >Diary Reports From : {{ fdate | date: "dd-MMM-yyyy" }} To
          {{ tdate | date: "dd-MMM-yyyy" }} </span
        ><br />
      </div>
    </div>
    <div class="row">
        <div class="col-md-12">
          <span style="font-size: 14px; font-weight: bold;"> Employee Name : </span>{{ userFname }}
          {{ userMname != "null" ? userMname : "" }} {{ userLname }}
      </div>
      </div>
    <div class="row">
      <div class="col-md-12">
        <table
          class="table table-bordered table-sm table-striped" 
          style="display: block; overflow-x: auto; white-space: nowrap"
        >
          <thead class="">
            <tr>
              <th>Diary Date</th>
              <th>Day</th>
              <th>Debit Hours</th>
              <th>Credit Hours</th>
              <th>Client Name</th>
              <th>Assignment</th>
              <th>Assignment For FY</th>
              <th>Task</th>
              <th>Work Performed</th>
              <th>In Time</th>
              <th>Out Time</th>
              <th>No Of Hours</th>
              <th>Travelling From</th>
              <th>Mode</th>
              <th>Distance in Kms</th>
              <th>Rate</th>
              <th>Amount</th>
              <th>Approver Name</th>
              <th>Diary Approval Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let rep of reports
                  | slice: (page - 1) * pageSize:page * pageSize
              "
            >
              <td>{{ rep.diaryDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ rep.diaryDate | date: "EEEE" }}</td>
              <td>{{ rep.debitHrs + "." + rep.debitMin }}</td>
              <td>{{ rep.creditHrs + "." + rep.creditMin }}</td>
              <td>{{ rep.clientName }}</td>
              <td>{{ rep.assignment }}</td>
              <td>{{ rep.assignmentFYYear }}</td>
              <td>{{ rep.task }}</td>
              <td>{{ rep.workPerformed }}</td>
              <td>{{ rep.inTimeHr + "." + rep.inTimeMin }}</td>
              <td>{{ rep.outTimeHr + "." + rep.outTimeMin }}</td>
              <td>{{ rep.noOfHoursHr + "." + rep.noOfHoursMin }}</td>
              <td>{{ rep.travellingFrom }}</td>
              <td>{{ rep.mode }}</td>
              <td>{{ rep.distanceInKm }}</td>
              <td>{{ rep.rate }}</td>
              <td>{{ rep.amount }}</td>
              <td>
                {{ rep.approver == null ? "Self Approved" : rep.approver }}
              </td>
              <td>{{ rep.approvalDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ rep.status }}</td>
            </tr>
            <tr *ngIf="reports.length != 0 && showRow">
              <td>Total</td>
              <td></td>
              <td>{{ totalDebitHr + totalDebitMin }}</td>
              <td>{{ totalCreditHr + totalCreditMin }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{ totalNoOfHr + totalNoOfMin }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{ totalAmount }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr *ngIf="reports.length == 0">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>No Entries available</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <ngb-pagination
          (pageChange)="pageChanged($event)"
          [pageSize]="pageSize"
          [collectionSize]="reports.length"
          [maxSize]="20"
          [(page)]="page"
          aria-label="Default pagination"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</div>

